import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import Logout from 'client/components/Logout';
import { joinRegex } from 'client/hooks/useInitPromo/useInitPromo';
import { isDoNotShowCheckRecordsBtnGames } from 'config/promoGameTypesClientConfig';
import { setTextVariantStyle } from 'utils/variantStyle';
import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';
import ViewRecordsBtn from 'editor/game_checkIn/components/ViewRecordsBtn';
import useResultPage from 'hooks/useResultPage';
import EntriesList from './Result/EntriesInfo/EntriesList';
import { system900 } from 'Mui/styles/color';
import { gameTypes } from 'config/promoGameTypes';

const FooterActionButton = () => {
    const gameType = useSelector(s => s.promo.type);
    const themeStyle = usePromoSettingThemeStyle();
    const { enableCoverPage } = useSelector(s => s.settingPromo);
    const { isCoverPagePhase } = useSelector(s => s.userEntryState);
    const resultPage = useResultPage();
    const { recordButtonText } = resultPage;
    const isJoinPage = Boolean(window.location?.pathname?.match(joinRegex));
    const userGameResultRecords = useSelector(s => s.userGameResultRecords);
    const isCoverPage = enableCoverPage && isCoverPagePhase && isJoinPage;

    const shouldHideRecordBtn = useMemo(
        () =>
            // 不是 join page 或 參加及結果模組
            (isJoinPage && !isDoNotShowCheckRecordsBtnGames(gameType)) ||
            // 參加及結果模組但沒有任何遊戲結果記錄
            (isJoinPage &&
                isDoNotShowCheckRecordsBtnGames(gameType) &&
                userGameResultRecords.length === 0) ||
            gameType === gameTypes.MGM_SHARE,
        [gameType, isJoinPage, userGameResultRecords.length]
    );

    return (
        <div css={containerStyle(!shouldHideRecordBtn)}>
            <div
                css={buttonContainerStyle(
                    isCoverPage ? themeStyle.contentBgColor : 'transparent',
                    !shouldHideRecordBtn
                )}
            >
                {!shouldHideRecordBtn && (
                    <ViewRecordsBtn
                        btnStyle={recordButtonStyle(themeStyle.titleColor)}
                        variant="medium"
                        customText={recordButtonText}
                    >
                        <EntriesList
                            items={userGameResultRecords}
                            gameType={gameType}
                            needShowFormBtn
                        />
                    </ViewRecordsBtn>
                )}
                <Logout customWrapperStyle={logoutWrapperStyle} customStyle={logoutButtonStyle} />
            </div>
        </div>
    );
};

export default FooterActionButton;

const containerStyle = shouldShowBorder => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 11px 0;
    ${shouldShowBorder && `border-top: 1px solid ${system900.color}20;`}
`;

const buttonContainerStyle = (bgColor, hasBothButtons) => css`
    display: flex;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    background-color: ${bgColor};
    ${hasBothButtons && 'gap: 4px;'}
    &:empty {
        display: none;
    }
`;

const recordButtonStyle = textColor => css`
    ${setTextVariantStyle('subtitle2')}
    cursor: pointer;
    text-align: center;
    color: ${textColor};
    padding: 0px;
    line-height: 24px;
    border: none;
    padding: 0px 16px;
    text-decoration: underline;
    &:hover {
        background-color: transparent;
        border: none;
        text-decoration: underline;
    }
    &:active {
        box-shadow: none;
        border: none;
    }
`;

const logoutWrapperStyle = css`
    ${setTextVariantStyle('subtitle2')}
    cursor: pointer;
    text-align: center;
    padding: 0px 16px;
`;

const logoutButtonStyle = css`
    ${setTextVariantStyle('subtitle2')}
    line-height: 0;
`;
